import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsComponent } from './settings.component';
import { MaterialModule } from 'src/app/material.module';
import { TipuriAmenziModule } from '../tipuri-amenzi/tipuri-amenzi.module';
import { TipuriTaxeNedebitateModule } from '../tipuri-taxe-nedebitate/tipuri-taxe-nedebitate.module';

@NgModule({
    declarations: [SettingsComponent],
    imports: [
        CommonModule,
        MaterialModule,
        TipuriAmenziModule,
        TipuriTaxeNedebitateModule,
    ],
    exports: [SettingsComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SettingsModule { }
